export default __webpack_public_path__ + "static/media/Losmaskapitos.5f8640ec.jpeg";